import { createRouter, createWebHashHistory } from 'vue-router';
import { isLoggedIn, getHasBoundDevices, requireLogin } from '@/utils/auth';

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { public: true }
  },
  {
    path: '/device',
    name: 'Device',
    component: () => import('@/views/device/DeviceView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/device/add',
    name: 'AddDevice',
    component: () => import('@/views/device/AddDeviceView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/device/timer',
    name: 'TimerSettings',
    component: () => import('@/views/device/TimerView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/community',
    name: 'Community',
    component: () => import('@/views/community/CommunityView.vue'),
    meta: { public: true }
  },
  {
    path: '/device/sensor-chart',
    name: 'SensorChartView',
    component: () => import('@/views/device/SensorChartView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/community/post/:id',
    name: 'PostDetail',
    component: () => import('@/views/community/PostDetailView.vue'),
    meta: { public: true }
  },
  {
    path: '/community/post/new',
    name: 'NewPost',
    component: () => import('@/views/community/NewPostView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/views/mine/MineView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mine/edit',
    name: 'EditProfile',
    component: () => import('@/views/mine/EditProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mine/posts',
    name: 'MyPosts',
    component: () => import('@/views/mine/MinePostsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mine/favorites',
    name: 'MyFavorites',
    component: () => import('@/views/mine/MineFavoritesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mine/likes',
    name: 'MyLikes',
    component: () => import('@/views/mine/MineLikesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mine/following',
    name: 'MyFollowing',
    component: () => import('@/views/mine/MineFollowingView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mine/followers',
    name: 'MyFollowers',
    component: () => import('@/views/mine/MineFollowersView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mine/others/:id',
    name: 'OtherProfile',
    component: () => import('@/views/mine/MineOthersView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Login.vue'),
    meta: { public: true }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// 全局前置守卫：检查登录状态与根路径分流
router.beforeEach(async (to, from, next) => {
  console.log(to)
  // 已登录用户访问根路径：有绑定设备则进入设备页，否则进入首页
  if (to.path === '/') {
    if(isLoggedIn()) {
      const hasDevices = await getHasBoundDevices();
      if (hasDevices) {
        next('/device');
      } else {
        next('/home');
      }
    } else {
      next('/home');
    }
    return;
  }
  console.log(to)
  // 公开路由（首页、社区、帖子详情、登录页）无需登录即可访问
  if (to.meta.public) {
    next();
    return;
  }

  // 未登录访问受保护路由：弹窗提示，确认则跳转登录页，取消则停留当前页
  if (!isLoggedIn()) {
    const confirmed = await requireLogin();
    if (confirmed) {
      next({ name: 'Login', query: { redirect: to.fullPath } });
    } else {
      next(false);
    }
    return;
  }

  // 已登录访问其他受保护路由：放行
  next();
});

export default router;